import type {Nullable} from '../../utility-types';
import type {RpcError, RpcErrorCode} from './types';

import {NetworkError} from '../app';

/**
 * Base api response error.
 * User for extending or not known api error.
 */
export class RpcRequestError extends NetworkError {
  override code: RpcErrorCode = 'error.undefined';
  data: Nullable<RpcError['data']> = null;
  isBatchError = false;
  sentParams: any;

  constructor({code, data, message}: RpcError, sentParams: any) {
    super(code, typeof data?.reason === 'string' ? data.reason : message);

    this.name = 'RpcRequestError';
    this.code = code;
    this.sentParams = sentParams;

    if (data) {
      this.data = data;
    }
  }

  get reason() {
    return this.data?.reason ?? '';
  }
}
